import theme from 'styles';

export default (language, isBold) => {
  if (language === 'ru-RU') {
    return isBold ? theme.fonts.russianBold : theme.fonts.russianDefault;
  }
  return isBold ? theme.fonts.bold : theme.fonts.default;
};
